module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Fc-Gd-Hc-Ia.e9219683.png";